<div class="display-flex display-layout-column">
  <div class="display-layout-row">
    <div class="display-flex display-layout-column gap-15">
      <div class="dialog-header display-layout-column gap-5">
        <div class="display-layout-row justify-content-space-between align-items-center">
          <div>{{ title }}</div>
          <button mat-icon-button (click)="onCancel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-divider></mat-divider>
      </div>
      <div class="display-flex display-layout-column">
        <mat-dialog-content  class="content">
          <ng-content></ng-content>
        </mat-dialog-content>

      </div>
      <ng-container >
        <mat-dialog-actions align="end">
            <button mat-button (click)="onCancel()">
              {{ cancelButton }}
            </button>
            <button
              mat-stroked-button
              [disabled]="disableAction"
              (click)="onSubmit()"
            >
              {{ submitButton }}
            </button>
        </mat-dialog-actions>
      </ng-container>
    </div>
  </div>
</div>
